import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Validation from '../../../utils/validation';
import { NotificationAlertService } from 'src/app/services/notification-alert.service';
import { LoginService } from 'src/app/services/login.service';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrl: './create-password.component.scss'
})
export class CreatePasswordComponent {
  createPassForm: FormGroup = new FormGroup({
    password: new FormControl(''),
    confirmPass: new FormControl(''),
  });
  submitted = false;
  resetLink = false;
  showCreatePass = false;
  showConfirmPass = false;

  constructor(private fb: FormBuilder,
    private router: Router, private cStorage: ClientSideStorageService,
    private notifyService: NotificationAlertService, private loginService: LoginService) {
    this.createPasswordForm();
  }

  ngOnInit() {
    this.submitted = false;
  }

  createPasswordForm() {
    this.createPassForm = this.fb.group({
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(30)
      ]],
      confirmPass: ['', Validators.required]
    },
      {
        validators: [Validation.match('password', 'confirmPass')]
      }
    );
  }

  get f() {
    return this.createPassForm.controls;
  }

  onSubmit() {
    // this.submitted = true;
    if (this.createPassForm.invalid) {
      if (this.createPassForm.controls['password'].touched !== true && this.createPassForm.controls['confirmPass'].touched !== true) {
        this.notifyService.showError("Fields cannot be Empty", "Invalid");
      } else if (this.createPassForm.controls['password'].touched !== true) {
        this.notifyService.showError("Password cannot be Empty", "Invalid");
      } else if (this.createPassForm.controls['confirmPass'].touched !== true) {
        this.notifyService.showError("Re-Enter  cannot be Empty", "Invalid");
      } else {
        this.notifyService.showError("Invalid Fields", "Invalid");
      }
    } else {
      const country = JSON.parse(this.cStorage.get("country"));
      const macAddress = JSON.parse(this.cStorage.get("macAddress"));
      const token = JSON.parse(this.cStorage.get("passwordToken"));
      const email_id = JSON.parse(this.cStorage.get("userName"));
      let data = {
        email_id: email_id,
        token: token?.body.data,
        password: this.createPassForm.value.password
      }
      this.loginService.saveUpdatePassword(data, country, macAddress).subscribe((res:any) => {
        if(res.body?.status !== "Error") {
          this.notifyService.showSuccess(            
            "Password updated successfully !",
            res.body?.status
          );
          this.router.navigate(["./login"]);        
        } else if (res.body?.status !== "Error") {
          this.notifyService.showSuccess(            
            res.body?.message,
            res.body?.status
          );  
        }
      });
    }
  }

  togglePasswordVisibility() {
    this.showCreatePass = !this.showCreatePass;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPass = !this.showConfirmPass;
  }

}
